<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">Serviços</div>
      </unicom-coluna>
    </unicom-linha>

    <hospital-dia-componente
      v-if="objetoServicos['Hospital Dia'].ativo"
      :servico="objetoServicos['Hospital Dia']"
      :dadosServidor="this.dadosServidor"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></hospital-dia-componente>

    <pronto-socorro-componente
      v-if="objetoServicos['Pronto Socorro'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Pronto Socorro']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></pronto-socorro-componente>

    <pronto-atendimento-componente
      v-if="objetoServicos['Pronto Atendimento'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Pronto Atendimento']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></pronto-atendimento-componente>

    <laboratorio-componente
      v-if="objetoServicos['Laboratório'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Laboratório']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></laboratorio-componente>

    <centro-diagnostico-componente
      v-if="objetoServicos['Centro de Diagnóstico'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Centro de Diagnóstico']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></centro-diagnostico-componente>

    <medico-eletivo-componente
      v-if="objetoServicos['Atendimento Médico Eletivo'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Atendimento Médico Eletivo']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></medico-eletivo-componente>

    <atencao-domiciliar-componente
      v-if="objetoServicos['Serviço de Atenção Domiciliar'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Serviço de Atenção Domiciliar']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></atencao-domiciliar-componente>

    <agencia-transfusional-componente
      v-if="objetoServicos['Agência Transfusional'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Agência Transfusional']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></agencia-transfusional-componente>

    <servico-remocao-componente
      v-if="objetoServicos['Serviço de Remoção'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Serviço de Remoção']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></servico-remocao-componente>

    <outros-servicos-componente
      v-if="objetoServicos['Outros'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Outros']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></outros-servicos-componente>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "./ServicosMixin";

import HospitalDiaComponente from "./components/HospitalDiaComponente.vue";
import LaboratorioComponente from "./components/LaboratorioComponente.vue";
import CentroDiagnosticoComponente from "./components/CentroDiagnosticoComponente.vue";
import ProntoSocorroComponente from "./components/ProntoSocorroComponente.vue";
import MedicoEletivoComponente from "./components/MedicoEletivoComponente.vue";
import ServicoRemocaoComponente from "./components/ServicoRemocaoComponente.vue";
import AtencaoDomiciliarComponente from "./components/AtencaoDomiciliarComponente.vue";
import AgenciaTransfusionalComponente from "./components/AgenciaTransfusionalComponente.vue";
import ProntoAtendimentoComponente from "./components/ProntoAtendimentoComponente.vue";
import OutrosServicosComponente from "./components/OutrosServicosComponente.vue";

export default {
  mixins: [ServicosMixin],
  components: {
    HospitalDiaComponente,
    LaboratorioComponente,
    CentroDiagnosticoComponente,
    ProntoSocorroComponente,
    MedicoEletivoComponente,
    ServicoRemocaoComponente,
    AtencaoDomiciliarComponente,
    AgenciaTransfusionalComponente,
    ProntoAtendimentoComponente,
    OutrosServicosComponente
  },
  data() {
    return {};
  },
  methods: {
    prepararPayloadServicos(payloadDoComponente) {
      if (!payloadDoComponente) return;

      this.objetoServicos[payloadDoComponente.tipoServico].payload = {
        ...payloadDoComponente
      };

      if (payloadDoComponente.clickSwitch) {
        this.objetoServicos[payloadDoComponente.tipoServico].preenchido = true;
      }

      this.preparaDadosServicos();
    },
    switchHandler(payload) {
      this.objetoServicos[payload.tipoServico].preenchido = payload.clickSwitch;

      if (!payload.clickSwitch) {
        this.payloadServicos = this.payloadServicos.filter(
          servico => servico.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadEspecialidades = this.payloadEspecialidades.filter(
          espe => espe.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadAbrancencias = this.payloadAbrancencias.filter(
          abran => abran.tipoServico.tipoServico !== payload.tipoServico
        );
      }

      this.preparaDadosServicos();

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias
      });
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
